export const BALANCES_FEATURES = {
  moduleKey: 'balances',
  features: ['balances'] as const,
  featureMeta: {
    balances: {
      name: 'Balances',
      translations: { name: { de: 'Guthaben', en: 'Balances', fr: 'Soldes', it: 'Saldi' } },
    },
  },
} as const;
